

































import { Component, Vue } from 'vue-property-decorator';
import Socials from '@/components/Socials.vue'

@Component({
  components: {
    Socials,
  },
})

export default class HeaderBody extends Vue {}
